<script setup>
import AlertActionsCell from "@frontJs/components/tables/cells/projectManagement/alerts/AlertActionsCell.vue";
import LoadingSpinner from "@js/components/LoadingSpinner.vue";
import DataTableLayout from "@js/components/tables/DataTableLayout.vue";
import DangerIconCell from "@js/components/tables/cells/DangerIconCell.vue";
import TextCellV2 from "@js/components/tables/cells/TextCellV2.vue";
import { useDataTable } from "@js/utils/dataTable";
import { useRoute } from "@js/utils/route";
import { createColumnHelper } from "@tanstack/vue-table";
import { h } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { tenant, all } = defineProps({
  tenant: {
    type: Object,
    required: false,
  },
  all: {
    type: Boolean,
    required: false,
  },
});

const { route } = useRoute();

const columnHelper = createColumnHelper();

const {
  loading,
  table,
  count,
  globalFilter,
  filters,
  availableFilters,
  setGlobalFilter,
  setFilters,
} = useDataTable({
  columns: [
    columnHelper.accessor(() => null, {
      id: "tenant",
      header: () => t("label.customer"),
      cell: (props) =>
        h(TextCellV2, {
          text: props.row.original.tenant,
        }),
    }),
    columnHelper.accessor(() => null, {
      id: "group",
      header: () => t("label.group"),
      cell: (props) =>
        h(TextCellV2, {
          text: t("label." + props.row.original.group),
        }),
    }),
    columnHelper.accessor(() => null, {
      id: "message",
      header: () => t("label.message"),
      cell: (props) =>
        h(TextCellV2, {
          text: props.row.original.message,
          length: 300,
        }),
    }),
    columnHelper.accessor(() => null, {
      id: "severity",
      header: () => t("label.severity"),
      cell: (props) =>
        h(DangerIconCell, {
          color:
            props.row.original.severity === 1
              ? "green"
              : props.row.original.severity === 2
                ? "yellow"
                : "red",
        }),
    }),
    columnHelper.display({
      id: "actions",
      header: t("label.actions"),
      cell: (props) =>
        h(AlertActionsCell, {
          row: props.row,
        }),
    }),
  ],
  url: route("front.projectManagement.postAlerts", {
    tenant: tenant ? tenant.id : null,
    all,
  }),
  columnVisibility: {
    "tenant.name": !tenant,
    id: !!tenant,
  },
});
</script>

<template>
  <LoadingSpinner v-if="loading" />

  <DataTableLayout
    v-else
    :table="table"
    :count="count"
    :global-filter="globalFilter"
    :filters="filters"
    :available-filters="availableFilters"
    :set-filters="setFilters"
    :set-global-filter="setGlobalFilter"
  >
  </DataTableLayout>
</template>
